/* YakJak — Find My Drop Size calculator.
   Config comes from the section schema, so the hitch spec is editable in the
   Theme Editor without touching this file. */
(function () {
  'use strict';

  function parseInches(raw) {
    if (!raw) return null;
    var s = String(raw).trim().replace(/["\u201D\u2033]/g, '').replace(/\s*in(ch(es)?)?\.?$/i, '');
    if (!s) return null;
    var m = s.match(/^(\d+(?:\.\d+)?)\s+(\d+)\s*\/\s*(\d+)$/);
    if (m) return parseFloat(m[1]) + parseInt(m[2], 10) / parseInt(m[3], 10);
    m = s.match(/^(\d+)\s*\/\s*(\d+)$/);
    if (m) return parseInt(m[1], 10) / parseInt(m[2], 10);
    m = s.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return parseFloat(m[1]);
    return null;
  }

  function fmt(n) {
    var sign = n < 0 ? '-' : '';
    n = Math.abs(n);
    var whole = Math.floor(n + 1e-9);
    var eighths = Math.round((n - whole) * 8);
    if (eighths === 8) { whole += 1; eighths = 0; }
    if (eighths === 0) return sign + whole + '"';
    var num = eighths, den = 8;
    while (num % 2 === 0) { num /= 2; den /= 2; }
    return sign + (whole ? whole + ' ' : '') + num + '/' + den + '"';
  }

  function positions(m) {
    var out = [], step = m.step > 0 ? m.step : 1;
    for (var d = m.minDrop; d <= m.maxDrop + 1e-9; d += step) out.push(Math.round(d * 100) / 100);
    return out;
  }

  function bestFor(models, need) {
    var best = null;
    models.forEach(function (m) {
      if (m.enabled === false) return;
      positions(m).forEach(function (p) {
        var err = Math.abs(p - need);
        var cand = { model: m, pos: p, err: err, resid: p - need };
        if (!best) { best = cand; return; }
        if (err < best.err - 1e-9) { best = cand; return; }
        if (Math.abs(err - best.err) < 1e-9) {
          if (m.maxDrop < best.model.maxDrop) best = cand;
          else if (m.id === best.model.id && p > best.pos) best = cand;
        }
      });
    });
    return best;
  }

  function row(dt, dd) {
    return '<div class="yj-row"><dt>' + dt + '</dt><dd>' + dd + '</dd></div>';
  }

  function init(uid) {
    var root = document.getElementById('yjdf-' + uid);
    var cfgEl = document.getElementById('yjCfg-' + uid);
    if (!root || !cfgEl) return;

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var models = (cfg.models || []).filter(function (m) { return m.enabled !== false; });
    if (!models.length) return;
    var TOL = cfg.tolerance || 1;
    var maxReach = Math.max.apply(null, models.map(function (m) { return m.maxDrop; }));

    var q = function (name) { return root.querySelector('[data-yj="' + name + '"]'); };
    var recv = q('recv'), coup = q('coup'), res = q('result'), flag = q('flag'),
        head = q('headline'), sub = q('sub'), rows = q('rows'), note = q('note'), cta = q('cta');
    if (!recv || !coup || !res) return;

    var LAST = null;

    function ballChoice() {
      var el = root.querySelector('[data-yj="ball"]:checked');
      return el ? el.value : '2';
    }
    function ballLabel() {
      var v = ballChoice();
      if (v === '2') return '2"';
      if (v === '2.3125') return '2-5/16"';
      return 'Unknown';
    }
    function ballText() {
      var v = ballChoice();
      if (v === '2') return 'Use the 2&Prime; ball.';
      if (v === '2.3125') return 'Use the 2-5/16&Prime; ball \u2014 flip the ball post over.';
      return 'Check the stamp on your coupler, then use the matching ball. Both are on the hitch.';
    }

    function syncForm() {
      var map = {
        f_recv: LAST ? fmt(LAST.A) : '',
        f_coup: LAST ? fmt(LAST.B) : '',
        f_need: LAST ? fmt(Math.abs(LAST.need)) : '',
        f_dir: LAST ? LAST.direction : '',
        f_model: LAST && LAST.modelName ? LAST.modelName : 'None',
        f_pos: LAST && LAST.pos != null ? fmt(LAST.pos) : '',
        f_fit: LAST ? LAST.fit : '',
        f_att: LAST && LAST.attitude ? LAST.attitude : '',
        f_ball: ballLabel(),
        f_body: LAST
          ? ('Receiver ' + fmt(LAST.A) + ', coupler ' + fmt(LAST.B) + ', ' +
             fmt(Math.abs(LAST.need)) + ' ' + LAST.direction.toLowerCase() + ' needed. Result: ' +
             (LAST.modelName || 'no YakJak fits') +
             (LAST.pos != null ? ' at ' + fmt(LAST.pos) : '') + '.')
          : 'Drop size request (no measurements entered).'
      };
      Object.keys(map).forEach(function (k) {
        var el = q(k);
        if (el) el.value = map[k];
      });
    }

    function compute() {
      var A = parseInches(recv.value), B = parseInches(coup.value);
      if (A === null || B === null) { res.hidden = true; LAST = null; syncForm(); return; }

      res.hidden = false;
      if (cta) cta.style.display = '';

      if (A <= 0 || B <= 0 || A > 60 || B > 60) {
        flag.className = 'yj-flag yj-is-stop'; flag.textContent = 'Check that';
        head.textContent = 'Those numbers look off';
        sub.textContent = 'Receiver and coupler heights are normally somewhere between 10 and 30 inches. Give them another look.';
        rows.innerHTML = ''; note.textContent = '';
        if (cta) cta.style.display = 'none';
        LAST = null; syncForm(); return;
      }

      var need = A - B, isRise = need < 0, mag = Math.abs(need);
      var direction = isRise ? 'Rise' : 'Drop';
      var dirLower = direction.toLowerCase();

      if (mag < 1) {
        flag.className = 'yj-flag yj-is-warn'; flag.textContent = 'Barely any drop';
        head.textContent = 'You need almost no drop';
        sub.innerHTML = 'Your receiver and coupler are within ' + fmt(mag) + ' of each other, so you\u2019re close to level already.';
        rows.innerHTML = row('Receiver height (A)', fmt(A)) + row('Coupler height (B)', fmt(B)) +
                         row('Difference', fmt(mag) + ' ' + dirLower);
        note.innerHTML = '<strong>Our honest read:</strong> a YakJak set to its shallowest position will still drop you a couple of inches, which would put your trailer nose-down. A straight ball mount is probably the better buy here. ' + ballText();
        LAST = { A: A, B: B, need: need, direction: 'Level', fit: 'Near level', modelName: null, pos: null, attitude: '' };
        syncForm(); return;
      }

      if (isRise && !cfg.canFlipForRise) {
        flag.className = 'yj-flag yj-is-stop'; flag.textContent = 'Not a fit';
        head.textContent = 'You need ' + fmt(mag) + ' of rise';
        sub.textContent = 'Your coupler sits higher than your receiver, and our hitch does not invert for rise.';
        rows.innerHTML = row('Receiver height (A)', fmt(A)) + row('Coupler height (B)', fmt(B)) + row('Rise needed', fmt(mag));
        note.innerHTML = '<strong>Straight answer:</strong> you want a rise ball mount, not a drop hitch. We don\u2019t make one.';
        LAST = { A: A, B: B, need: need, direction: direction, fit: 'Out of range', modelName: null, pos: null, attitude: '' };
        syncForm(); return;
      }

      var best = bestFor(models, mag);

      if (!best || best.err > TOL) {
        flag.className = 'yj-flag yj-is-stop'; flag.textContent = 'Not a fit';
        head.textContent = 'You need ' + fmt(mag) + ' of ' + dirLower;
        sub.innerHTML = 'That\u2019s outside what our hitches reach. We\u2019d rather tell you than sell you the wrong part.';
        rows.innerHTML = row('Receiver height (A)', fmt(A)) + row('Coupler height (B)', fmt(B)) +
                         row(direction + ' needed', fmt(mag)) +
                         (best ? row('Closest we make', best.model.name + ' at ' + fmt(best.pos)) : '');
        note.innerHTML = '<strong>What we\u2019d do:</strong> look for a ' + fmt(Math.round(mag)) + ' ' + dirLower +
                         ' mount from someone who makes one. Leave your email below and we\u2019ll tell you if we ever build this size.';
        if (cta) { cta.textContent = cfg.ctaLabel || 'See the hitch'; cta.setAttribute('href', cfg.shopUrl || '/'); }
        LAST = { A: A, B: B, need: need, direction: direction, fit: 'Out of range',
                 modelName: null, pos: null, attitude: '', oversize: mag > maxReach };
        syncForm(); return;
      }

      var resid = best.resid, exact = Math.abs(resid) < 0.05;
      var noseDown = isRise ? (resid < 0) : (resid > 0);
      var attitude = exact ? 'Dead level' : (fmt(Math.abs(resid)) + (noseDown ? ' nose-down' : ' nose-high'));

      flag.className = 'yj-flag' + (exact ? '' : ' yj-is-warn');
      flag.textContent = exact ? 'Exact fit' : 'Good fit';
      head.textContent = best.model.name;
      sub.innerHTML = 'Set to the <strong>' + fmt(best.pos) + ' ' + dirLower + '</strong> position' +
                      (isRise ? ', with the hitch flipped over.' : '.');

      rows.innerHTML = row('Receiver height (A)', fmt(A)) + row('Coupler height (B)', fmt(B)) +
                       row(direction + ' needed', fmt(mag)) +
                       row('Hitch position', fmt(best.pos) + ' ' + dirLower) +
                       row('Your trailer will sit', attitude);

      if (exact) {
        note.innerHTML = '<strong>That\u2019s dead on.</strong> ' + ballText();
      } else if (noseDown) {
        note.innerHTML = '<strong>Slightly nose-down, which is the safe side.</strong> Nose-high moves weight behind the trailer axles and invites sway, so if you can\u2019t hit exact, this is the direction to miss in. ' + ballText();
      } else {
        note.innerHTML = '<strong>Heads up \u2014 this sits slightly nose-high.</strong> Nose-high shifts weight rearward and is the setup most likely to sway. It\u2019s within an inch so it will tow, but load your trailer front-heavy and keep an eye on it. ' + ballText();
      }

      if (cta) {
        cta.textContent = 'See the ' + best.model.name.replace(/^YakJak\s+/i, '');
        cta.setAttribute('href', best.model.url || cfg.shopUrl || '/');
      }

      LAST = { A: A, B: B, need: need, direction: direction, fit: exact ? 'Exact' : 'Good',
               modelName: best.model.name, pos: best.pos, attitude: attitude };
      syncForm();
    }

    ['input', 'change'].forEach(function (ev) {
      recv.addEventListener(ev, compute);
      coup.addEventListener(ev, compute);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-yj="ball"]'), function (el) {
      el.addEventListener('change', compute);
    });

    /* hero video: the media attribute on <source> is ignored inside <video>,
       so pick the file here before anything downloads */
    var v = document.getElementById('yjVid-' + uid);
    if (v) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        root.classList.add('yj-novideo');
      } else {
        var narrow = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
        var src = narrow ? v.getAttribute('data-mobile') : v.getAttribute('data-desktop');
        if (src) {
          v.src = src;
          v.load();
          var p = v.play();
          if (p && p.catch) p.catch(function () { root.classList.add('yj-novideo'); });
        } else {
          root.classList.add('yj-novideo');
        }
      }
    }

    compute();
  }

  function boot() {
    (window.YJDF_SECTIONS || []).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme Editor: re-initialise when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[id^="yjdf-"]');
    if (el) init(el.id.replace('yjdf-', ''));
  });
})();
